import { createContext, useReducer } from "react";

export const ToolsContext = createContext(null);
export const ToolsDispatchContext = createContext(null);
export const ToolsSelectionContext = createContext(null);
export const ToolsSelectionDispatchContext = createContext(null);

export class Tool {
  constructor(name, icon, description = null) {
    this.name = name;
    this.icon = icon;
    this.description = description;
    this.selection = null;
    this.propertyEditor = null;
  }
}

export class Toolset {
  constructor() {
    this.tools = {};
  }

  addTool(tool) {
    if(! tool instanceof Tool) {
      throw new Error('Parameter must be instance of Tool');
    }
    this.tools[tool.name] = tool;
  }
}

export const mainToolset = new Toolset();
mainToolset.addTool(new Tool('selectTool','fa-solid fa-arrow-pointer'));
mainToolset.addTool(new Tool('stopsTool','fa-solid fa-location-dot','Przystanki i dworce'));
mainToolset.addTool(new Tool('segmentsTool','fa-solid fa-route','Odcinki tras'));
mainToolset.addTool(new Tool('routesTool','fa-solid fa-timeline','Linie komunikacyjne i wzory tras'));
mainToolset.addTool(new Tool('calendarsTool','fa-solid fa-calendar-days','Kalendarze'));
mainToolset.addTool(new Tool('tripsTool','fa-solid fa-road','Kursy'));
mainToolset.addTool(new Tool('timetablesTool','fa-solid fa-table','Rozkłady liniowe'));

export function ToolProvider({ children }) {
    const [tool, dispatch] = useReducer(toolReducer, {...initialTool});

    return (
        <ToolsContext.Provider value={tool}>
            <ToolsDispatchContext.Provider value={dispatch}> 
                  {children}
            </ToolsDispatchContext.Provider>
        </ToolsContext.Provider>
    );
}


export function toolReducer(tool, action) {
  console.log('disp. tool:', tool);
  console.log('disp. action:', action);
    switch (action.type) {
      case 'changed': {
        return action.newTool;
      }
      case 'editProperties': {
        return {
          // todo: ??
        }
      }
      default: {
        throw Error('Unknown action: ' + action.type);    
      }
    }
  }

 const initialTool = mainToolset.tools['selectTool'];